export const menuItems = [
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        id: 3,
        label: 'menuitems.micoapp.text',
        icon: 'fas fa-globe-americas',
        link: '/micoapp'
    },
    {
        id: 19,
        label: 'menuitems.wechat.text',
        icon: 'ri-wechat-line',
        subItems: [
            {
                label: 'menuitems.wechat.wechatmp.text',
                link: '/wechat/mp'
            },
            {
                label: 'menuitems.wechat.micoapp.text',
                link: '/wechat/micoapp'
            }
        ]
    },
    {
        id: 18,
        isLayout: true
    }
]